import { Typography, TypographyProps } from '@mui/material';

interface Props extends TypographyProps {
  children: JSX.Element;
}

function TitleMd({ children, ...others }: Props): JSX.Element {
  return (
    <Typography variant="h3" {...others}>
      {children}
    </Typography>
  );
}

export default TitleMd;
